<template>
    <div class="container">
        <div class="card-container mb-10">
            <div class="title mb-10 font-weight-bold">
                <span>商品信息</span>
            </div>
            <div class="align-group-flex-start detail-container">
                <div>
                    询价标题：
                    <el-tooltip
                        v-if="shouldTruncate(productDetail.title || '', 'title')"
                        class="item"
                        effect="dark"
                        :content="productDetail.title"
                        placement="top-start"
                    >
                        <span>{{ titleDisplay }}</span>
                    </el-tooltip>
                    <span v-else>{{ productDetail.title }}</span>
                </div>
                <div>
                    询价单号：{{ productDetail.code }}
                </div>
                <div>
                    {{ productDetail.startDate.label }}：
                    <span class="text-danger">{{ productDetail.startDate.value }}</span>
                </div>
                <div>
                    询价单创建人：{{ productDetail.cname }}
                </div>
            </div>
            <div class="align-group-flex-start detail-container">
                <div>
                    城市：
                    <el-tooltip
                        v-if="shouldTruncate(productDetail.cityNames || '', 'cityNames')"
                        class="item"
                        effect="dark"
                        :content="productDetail.cityNames"
                        placement="top-start"
                    >
                        <span>{{ cityNamesDisplay }}</span>
                    </el-tooltip>
                    <span v-else>{{ productDetail.cityNames }}</span>
                </div>
                <div>
                    询价类型：{{ enquiryTypeDisplay }}
                </div>
                <div>
                    {{ productDetail.endDate.label }}：
                    <span class="text-danger">{{ productDetail.endDate.value }}</span>
                </div>
            </div>
            <div class="align-group-flex-start detail-container">
                <div>
                    补充说明：{{ productDetail.remark }}
                </div>
            </div>
        </div>
        <div class="card-container">
            <div class="title mb-10 font-weight-bold">
                <span>询价商品明细</span>
                <span
                    v-if="productCountNote"
                    class="text-danger"
                >:{{ productCountNote }}</span>
            </div>
            <xx-search-form
                v-model="query"
                :fields="searchFields"
                @submit="onSearch"
                @reset="onReset"
            >
                <template slot="skuId">
                    <el-input
                        v-model="query.skuId"
                        placeholder="请输入skuId"
                        :maxlength="30"
                    />
                </template>
                <template slot="skuName">
                    <el-input
                        v-model="query.skuName"
                        placeholder="请输入商品名称"
                        :maxlength="30"
                    />
                </template>
                <template
                    v-if="type==='TAB_PRICE_REPORTED'"
                    slot="searchbtn"
                >
                    <mc-button
                        type="primary"
                        @click="exportExcel"
                    >
                        导出
                    </mc-button>
                    <mc-gongji-upload
                        upload-text="导入报价"
                        :action="UPLOAD_ACTION.PRIVATE"
                        business-scene="vss_price_enquiry_list"
                        :data="privateUploadData"
                        accept=".xls,.xlsx"
                        :showFileList="false"
                        :multiple="false"
                        :on-error="()=>$message.error('上传失败，请稍后重试')"
                        :on-success="uploadSuccess"
                    />
                    <span class="configInfo">建议：1.报价拆解由财务协助进行拆分; 2.供应商利润率基于供应商采购价拆解,自动计算</span>
                </template>
            </xx-search-form>
        </div>
        <div class="card-container">
            <span class="promptInfo">注意：请按照正常场景报价，非促销场景；多多参与，可提升中标率</span>
            <el-form
                ref="priceForm"
                :model="priceForm"
            >
                <xx-table-pro
                    ref="table"
                    name="table"
                    source="local"
                    :columns="tableHeaders"
                    :local-data="priceForm.filteredList"
                    :spanMethod="objectSpanMethod"
                    :pagination="{show: false}"
                    row-span-key-name="skuId"
                    :header-cell-class-name="headerClzName"
                    :row-class-name="tableRowClassName"
                    class="table-form-class"
                >
                    <!-- 验收标准及描述 -->
                    <template
                        slot="standardDescription"
                        slot-scope="{row}"
                    >
                        <el-button
                            type="text"
                            class="no-padding"
                            @click="checkStandardDetail(row)"
                        >
                            查看详情
                        </el-button>
                    </template>
                    <!-- 供货城市 -->
                    <template
                        slot="cityName"
                        slot-scope="{row}"
                    >
                        <div class="flex align-center">
                            <!-- 不允许报价且为同商时展示同商标签，资质卡控返回""表示无需展示该标签 -->
                            <SimilarSupplier
                                v-if="!row.allowBid && row.notAllowBidReason && row.notAllowBidReason.tagName"
                                :row="row"
                                type="tag"
                            />
                            <div>{{ row.cityName }}</div>
                        </div>
                    </template>
                    <!-- 报价方式 -->
                    <template
                        slot="style"
                        slot-scope="{row}"
                    >
                        <xx-radio-group
                            v-model="row.reportType"
                            :disabled="!editable"
                            :list="reportRadioList"
                            class="quotation-radio"
                            @change="changeQuotStyle(row.reportType, row)"
                        />
                    </template>
                    <!-- 单价 -->
                    <template
                        slot="lastBidPrice"
                        slot-scope="{row}"
                    >
                        <template
                            v-if="editable"
                        >
                            <el-form-item
                                :ref="`priceFormItem-${row.index}`"
                                :prop="'filteredList.' + row.index"
                                :rules="priceCheck(row.reportType)"
                            >
                                <el-input
                                    v-if="row.allowBid"
                                    :id="`priceInput-${row.index}`"
                                    :ref="`priceRef-${row.index}`"
                                    v-model.number="row.lastBidPrice"
                                    type="number"
                                    :min="0"
                                    class="blue-border"
                                    @change="(val) => updateBargainPrice(val, row, 'lastBidPrice')"
                                />
                                <SimilarSupplier
                                    v-else
                                    :row="row"
                                />
                            </el-form-item>
                        </template>
                        <template v-else>
                            {{ row.lastBidPrice }}
                        </template>
                    </template>
                    <!-- 建议零售价 -->
                    <template
                        slot="recommendPrice"
                        slot-scope="{row}"
                    >
                        <template v-if="editable">
                            <el-input
                                v-if="row.allowBid"
                                v-model.number="row.recommendPrice"
                                type="number"
                                :min="0"
                                class="blue-border"
                                @change="(val) => handleRecommendPriceChange(val, row, 'recommendPrice')"
                            />
                            <SimilarSupplier
                                v-else
                                :row="row"
                            />
                        </template>
                        <template v-else>
                            {{ row.recommendPrice }}
                        </template>
                    </template>
                    <!-- 目标订货模式 -->
                    <template
                        slot="targetReplenishmentMode"
                        slot-scope="{row}"
                    >
                        {{ targetReplenishmentModeMap[row.targetReplenishmentMode] || '--' }}
                    </template>
                    <!-- 商支持订次 -->
                    <template
                        slot="replenishmentModeList"
                        slot-scope="{row}"
                    >
                        {{ ((row.replenishmentModeList && row.replenishmentModeList.length) ? row.replenishmentModeList : ['--']).join('、') }}
                    </template>
                    <!-- 本期可供数量(pcs) -->
                    <template
                        slot="supplyQuantity"
                        slot-scope="{row}"
                    >
                        <template v-if="editable">
                            <el-input
                                v-if="row.allowBid"
                                v-model.number="row.supplyQuantity"
                                type="number"
                                :min="0"
                            />
                            <SimilarSupplier
                                v-else
                                :row="row"
                            />
                        </template>
                        <template v-else>
                            {{ row.supplyQuantity }}
                        </template>
                    </template>
                    <!-- 产地 -->
                    <template
                        slot="sourcePlace"
                        slot-scope="{row}"
                    >
                        <template v-if="editable">
                            <el-input
                                v-if="row.allowBid"
                                v-model="row.sourcePlace"
                            />
                            <SimilarSupplier
                                v-else
                                :row="row"
                            />
                        </template>
                        <template v-else>
                            {{ row.sourcePlace }}
                        </template>
                    </template>
                    <!-- <template
                        slot="profitMargin"
                        slot-scope="{row}"
                    >
                        {{ row.profitMargin?`${row.profitMargin}%`:"--" }}
                    </template> -->
                    <!-- 拆解前端隐藏，后续产品会迭代加回来 -->
                    <!-- 报价-采购价BOM拆解 -->
                    <!-- <template
                        slot="bomPrice"
                        slot-scope="{row}"
                    >
                        <el-button
                            v-if="bomColumns&&bomColumns.length>0"
                            type="text"
                            @click="editBomDetail(row)"
                        >
                            <span :class="{ active: invalidIndexList.includes(row.index + 1) }">{{ type==='TAB_PRICE_REPORTED' ? '去填写' : '去查看' }}</span>
                        </el-button>
                        <span v-else> -- </span>
                    </template> -->
                    <!-- 商家补充描述 -->
                    <template
                        slot="remark"
                        slot-scope="{row}"
                    >
                        <template v-if="editable">
                            <el-input
                                v-if="row.allowBid"
                                v-model="row.remark"
                            />
                            <SimilarSupplier
                                v-else
                                :row="row"
                            />
                        </template>
                        <template v-else>
                            {{ row.remark }}
                        </template>
                    </template>
                    <template
                        slot="bargainState"
                        slot-scope="{row}"
                    >
                        <template v-if="row.bargainStateDisplay">
                            {{ row.bargainStateDisplay }}
                        </template>
                        <template v-else>
                            <el-radio-group v-model="row.bargainState">
                                <el-radio
                                    :label="1"
                                    :disabled="row.bargainStateDisabled"
                                >
                                    接受
                                </el-radio>
                                <el-radio
                                    :label="2"
                                    :disabled="row.bargainStateDisabled"
                                >
                                    拒绝
                                </el-radio>
                            </el-radio-group>
                        </template>
                    </template>
                </xx-table-pro>
            </el-form>
            <!-- 异常规则校验弹窗 -->
            <el-dialog
                title="友情提示"
                :visible.sync="dialogVisible"
                width="50%"
            >
                <div class="price-exception-info">
                    <i class="el-icon-error"></i>系统检测到以下商品，您的报价过高，请谨慎报价，谢谢！
                </div>
                <xx-table-pro
                    ref="infoTable"
                    source="local"
                    :pagination="{show: false}"
                    :local-data="localData"
                    :columns="localColumns"
                    name="infoTable"
                />
                <span
                    slot="footer"
                    class="dialog-footer"
                >
                    <el-button
                        type="primary"
                        size="small"
                        @click="keepPrice"
                    >继续报价</el-button>
                    <el-button
                        type="primary"
                        size="small"
                        @click="editPrice"
                    >返回修改</el-button>
                </span>
            </el-dialog>
        </div>
        <quality-standard-dialog ref="qualityStandardDialog" />
        <bom-detail-form
            ref="bomDetailForm"
            @updateData="updateBomDetail"
        />
    </div>
</template>
<script>
// eslint-disable-next-line
import { truncate } from 'lodash';
import { reportLx } from '@lsfe/tools';
import { DefaultPropConfig } from '../../config';
import {
    getDefaultSearchParamsForDetailPage,
    getSearchFormFieldsForDetailPage,
    detailPageSearchParamsPipeMap,
    productInfoTruncateLengthMap,
    enquiryEnumMap,
    priceExceptionInfoColumns,
    bomInputTableHeader,
    formatTimeHelper,
    TAB_PRICE_BARGAIN,
    TAB_PRICE_WAIT_REPORT,
    TAB_PRICE_REPORTED,
    bargainStateEnumMap,
    hasPriceCheck,
    REPORT_TYPE,
    targetReplenishmentModeMap,
    PRICE_REPORT_DETAIL_CID,
} from '../config';
import { UPLOAD_ACTION } from '../../../../../api/upload';
import { BUCKET_NAME, getPrivateUploadData } from '../../../../../common/constants';
import QualityStandardDialog from './QualityStandardDialog';
import BomDetailForm from './BomDetailForm';
import SimilarSupplier from './SimilarSupplier';

export default {
    name: 'DetailPage',
    components: { QualityStandardDialog, BomDetailForm, SimilarSupplier },
    props: {
        enquiryId: DefaultPropConfig.String(),
        type: DefaultPropConfig.String(),
        productDetail: DefaultPropConfig.Object({
            startDate: {},
            endDate: {},
        }),
        productCountNote: DefaultPropConfig.String(),
        list: DefaultPropConfig.Array(),
        columns: DefaultPropConfig.Array(),
        editable: DefaultPropConfig.Boolean(),

        bomColumns: DefaultPropConfig.Array(),
        extraBomHeader: DefaultPropConfig.Array(),
        invalidIndexList: DefaultPropConfig.Array(),
    },
    data() {
        return {
            dialogVisible: false,
            currentRow: 0,
            localColumns: priceExceptionInfoColumns,
            localData: [],
            query: getDefaultSearchParamsForDetailPage(),
            priceForm: {
                filteredList: [],
            },

            headerList: bomInputTableHeader,
            bomEditableType: [
                'TAB_PRICE_REPORTED', // 报价
                'TAB_PRICE_BARGAIN', // 议价
            ],
            reportRadioList: [
                { label: '统一报价', value: REPORT_TYPE.UNIFY },
                { label: '分城市报价', value: REPORT_TYPE.DIFFERENTIATE },
            ],
            targetReplenishmentModeMap,
            // 私有桶上传参数
            privateUploadData: getPrivateUploadData(),
            UPLOAD_ACTION,
        };
    },
    computed: {
        searchFields() {
            return getSearchFormFieldsForDetailPage();
        },
        tableHeaders() {
            return [...this.columns];
        },
        enquiryTypeDisplay() {
            return enquiryEnumMap[this.productDetail.enquiryType] || '';
        },
        cityNamesDisplay() {
            return truncate(
                this.productDetail && this.productDetail.cityNames,
                {
                    length: productInfoTruncateLengthMap.get('cityNames'),
                },
            );
        },
        titleDisplay() {
            return truncate(this.productDetail && this.productDetail.title, {
                length: productInfoTruncateLengthMap.get('title'),
            });
        },
    },
    watch: {
        list: {
            deep: false,
            handler(v) {
                this.priceForm.filteredList = this.handleFilteredList(v);
                this.batchQuotStyleReportLx();
            },
            immediate: false,
        },
    },
    methods: {
        handleFilteredList(list) {
            if (this.editable) {
                /** 保证每个sku下第一个城市是可以报价的,不然统一报价时，输入框会被禁止使用 */
                const sortObj = list.reduce((per, cur) => {
                    const { skuId } = cur;
                    if (!per[skuId]) {
                        per[skuId] = [];
                    }
                    per[skuId].push(cur);
                    return per;
                }, {});
                const newList = Object.values(sortObj);
                newList.forEach((itemList) => {
                    if (itemList[0].allowBid) {
                        return;
                    }
                    const index = itemList.findIndex((cItem) => cItem.allowBid);
                    if (index < 0) return;
                    const obj = itemList[index];
                    itemList.splice(index, 1);
                    itemList.splice(0, 0, obj);
                });
                return newList.reduce((per, cur) => {
                    cur.forEach((item) => {
                        per.push(item);
                    });
                    return per;
                }, []);
            }
            return list;
        },
        onSearch() {
            this.priceForm.filteredList = this.doFilter();
        },
        onReset() {
            this.query = getDefaultSearchParamsForDetailPage();
            this.priceForm.filteredList = this.list;
        },
        doFilter() {
            const list = this.list || [];
            const entries = Object.entries(this.query);
            return entries.reduce((prev, [key, value]) => {
                if (detailPageSearchParamsPipeMap.has(key)) {
                    prev = prev.filter((item) => detailPageSearchParamsPipeMap.get(key)(
                        item[key],
                        value,
                    ));
                }
                return prev;
            }, list);
        },
        shouldTruncate(str, key) {
            return str.length > productInfoTruncateLengthMap.get(key);
        },
        headerClzName({ column }) {
            if (this.headerList.includes(column.property)) return 'xx-text-danger';
            return '';
        },
        handleRecommendPriceChange(val, row, attr) {
            const { lastBidPrice } = row;
            if (val && !lastBidPrice) {
                this.$message.info('必须先填写报价，再填写建议零售价');
            }
            this.updateBargainPrice(hasPriceCheck(val) ? +val : null, row, attr);
        },

        // 报价异常校验
        priceCheck(reportType) {
            return {
                trigger: 'blur',
                validator: async (rule, value, callback) => {
                    // 请求后端接口：SKUID+城市+品类+供应商报价
                    if (value.lastBidPrice || value.lastBidPrice === 0) {
                        let rowParams = [];
                        if (reportType && reportType === REPORT_TYPE.UNIFY) {
                            rowParams = this.priceForm.filteredList.reduce((acc, item) => {
                                if (item.skuId === value.skuId) {
                                    acc.push({
                                        skuId: value.skuId,
                                        cityId: item.cityId,
                                        price: Number(item.lastBidPrice),
                                        amount: item.supplyQuantity,
                                        remark: item.remark,
                                    });
                                }
                                return acc;
                            }, []);
                        } else {
                            rowParams.push({
                                skuId: value.skuId,
                                cityId: value.cityId,
                                price: Number(value.lastBidPrice),
                                amount: value.supplyQuantity,
                                remark: value.remark,
                            });
                        }
                        try {
                            const res = await this.$hPost(
                                '/api/vss/shepherd/enquiry/bid/priceReasonable',
                                {
                                    enquiryId: this.enquiryId,
                                    skuOfferPriceList: rowParams,
                                },
                            );
                            if (!res.reasonable) {
                                callback(new Error('报价异常'));
                                this.dialogVisible = true;
                                this.currentRow = value.index;
                                this.localData = res.unreasonablePriceList;
                            } else {
                                // 报价正常
                                callback();
                            }
                        } catch (e) {
                            this.$message.error(e.message);
                        }
                    }
                },
            };
        },

        tableRowClassName({ row, rowIndex }) {
            // 把每一行的索引放进row
            row.index = rowIndex;
        },
        // 继续报价
        keepPrice() {
            this.dialogVisible = false;
            const rowIndex = this.currentRow + 1;
            // 需要考虑边界问题，即表格最后一行的情况
            if (this.$refs[`priceRef-${rowIndex}`]) {
                this.$refs[`priceRef-${rowIndex}`].focus();
            }
        },

        // 修改报价
        editPrice() {
            this.dialogVisible = false;
            const rowIndex = this.currentRow;
            this.$refs[`priceRef-${rowIndex}`].focus();
        },

        // 下载excel模板文件
        async exportExcel() {
            try {
                const fileUrl = await this.$hGet(
                    '/api/vss/shepherd/enquiry/bid/export',
                    { enquiryId: this.enquiryId },
                );
                this.$tools.download(fileUrl);
            } catch (err) {
                this.$message.error(err.message || '下载失败');
            }
        },
        async uploadSuccess(response) {
            const loading = this.$loading({ lock: true, text: '导入中' });
            try {
                // 使用上传接口返回的 fileName 作为后端入参
                const url = response.data.fileName;
                const result = await this.$hPost('/api/vss/shepherd/enquiry/bid/import', { url, enquiryId: this.enquiryId, bucketName: BUCKET_NAME.PRIVATE });
                if (result && result.length) {
                    result.forEach((item) => {
                        if (item.hasOwnProperty('lastBidTime')) {
                            item.lastBidTime = formatTimeHelper(item.lastBidTime);
                        }
                        const current = this.priceForm.filteredList.find((skuItem) => (+skuItem.skuId === +item.skuId && +skuItem.cityId === +item.cityId));
                        if (!current) {
                            this.priceForm.filteredList.push(item);
                            return;
                        }
                        item.reportType = REPORT_TYPE.DIFFERENTIATE;
                        Object.assign(current, item);
                    });
                }
            } catch (e) {
                this.$message.error(e.message);
            } finally {
                loading.close();
            }
        },

        checkStandardDetail(row) {
            this.$refs.qualityStandardDialog.popup({ skuId: row.skuId, enquiryId: this.enquiryId });
        },
        editBomDetail(row) {
            const params = {
                row,
                editable: this.type !== TAB_PRICE_BARGAIN || row.bargainState === bargainStateEnumMap.accept,
                bomColumns: this.bomColumns,
                extraBomHeader: this.extraBomHeader,
            };
            this.$refs.bomDetailForm.popup(params);
        },
        updateBomDetail({ columnValueList, index } = {}) {
            this.priceForm.filteredList[index].columnValueList = columnValueList;
        },
        objectSpanMethod({ row, column, rowIndex }) {
            const commonColumns = ['skuId', '商品名称', '规格', '单位', '验收标准及描述', '采购标准描述/备注', '报价方式'];
            const priceColumns = ['*单价（元）', '建议零售价'];
            // 分sku维度
            const isCommonColumn = commonColumns.includes(column.label);
            // 统一报价、分城市报价单元格特殊处理
            const isPriceColumn = priceColumns.includes(column.label) && (this.type === TAB_PRICE_WAIT_REPORT || this.type === TAB_PRICE_REPORTED) && row.reportType === REPORT_TYPE.UNIFY;
            if (isCommonColumn || isPriceColumn) {
                // 如果当前行不是第一行，并且当前行的skuId和上一行的skuId相同，则返回行跨度为0，列跨度为0
                if (rowIndex > 0 && row.skuId === this.priceForm.filteredList[rowIndex - 1].skuId) {
                    return {
                        rowspan: 0,
                        colspan: 0,
                    };
                }
                // 计算当前skuId在列表中的数量
                const count = this.priceForm.filteredList.filter((item) => item.skuId === row.skuId).length;
                return {
                    rowspan: count,
                    colspan: 1,
                };
            }
            return {
                rowspan: 1,
                colspan: 1,
            };
        },
        // 修改报价方式
        changeQuotStyle(reportType, row) {
            const { skuId } = row;

            // 清空同一SKU下所有城市的报价数据
            this.priceForm.filteredList.forEach((it) => {
                if (it.skuId === skuId) {
                    it.reportType = reportType;
                    it.lastBidPrice = null;
                    it.recommendPrice = null;
                    it.priceRankStr = null;
                }
            });

            // 触发埋点上报
            this.handleQuotStyleReportLx(row, reportType);
        },
        handleQuotStyleReportLx(row, reportType = REPORT_TYPE.DIFFERENTIATE) {
            const { skuId, skuName, lxSupplierInfo = {} } = row;
            const bid = reportType === REPORT_TYPE.DIFFERENTIATE ? 'b_chaoshi_kxyrzcex_mc' : 'b_chaoshi_19gpnd44_mc';
            const { cityNames, cityIds } = this.productDetail;
            const lxParams = {
                ...lxSupplierInfo,
                sku_id: skuId,
                sku_name: skuName,
                city_id: cityIds,
                city_name: cityNames,
            };
            reportLx('moduleClick', bid, lxParams, { cid: PRICE_REPORT_DETAIL_CID });
        },
        batchQuotStyleReportLx() {
            const waiteReportLx = this.priceForm.filteredList.reduce((per, cur) => {
                const { skuId } = cur;
                if (!per[skuId]) {
                    per[skuId] = [];
                }
                per[skuId].push(cur);
                return per;
            }, {});
            Object.values(waiteReportLx).forEach((item) => {
                if (item.length) {
                    this.handleQuotStyleReportLx(item[0]);
                }
            });
        },
        // 统一报价--价格更改
        updateBargainPrice(val, row, attr) {
            // 仅在"待报价"或"报价中"状态且为统一报价时触发同步逻辑
            if ([TAB_PRICE_WAIT_REPORT, TAB_PRICE_REPORTED].includes(this.type) && row.reportType === REPORT_TYPE.UNIFY) {
                // 同步更新该SKU下所有允许报价的城市价格
                this.priceForm.filteredList.forEach((it) => {
                    if (it.skuId === row.skuId && it.allowBid) {
                        it[attr] = val;
                    }
                });
            }
            if (attr === 'lastBidPrice') {
                this.updatePriceRank(row);
            }
        },
        async updatePriceRank(row) {
            let executeList = [];
            const {
                skuId, cityId, lastBidPrice: price, reportType,
            } = row;
            const body = {
                skuId,
                price: String(price),
                enquiryId: this.enquiryId,
                cityIdList: [cityId],
            };
            if (reportType === REPORT_TYPE.UNIFY) {
                executeList = this.priceForm.filteredList.filter((item) => item.skuId === skuId);
                body.cityIdList = executeList.map((item) => item.cityId);
            } else {
                executeList.push(row);
            }
            const rankList = await this.$hPost('/api/vss/shepherd/enquiry/bid/priceRank', body);
            (rankList || []).forEach((item) => {
                const curRank = executeList.find((cItem) => cItem.cityId === item.cityId);
                if (curRank) {
                    this.$set(curRank, 'priceRankStr', item.priceRankStr);
                }
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.container {
    .card-container {
        padding-top: 10px;
    }
    .title > span:first-child {
        font-weight: bold;
        font-size: 1.1em;
        border-left: 2px solid #47a1e3;
        padding-left: 10px;
    }
    .mb-10 {
        margin-bottom: 10px;
    }
    .mb-30 {
        margin-bottom: 30px;
    }
    .font-weight-bold {
        font-weight: bold;
    }
    .align-group-flex-start {
        display: flex;
        flex-flow: row wrap;
        justify-content: flex-start;
        align-items: center;
    }
    .detail-container > div {
        min-width: 280px;
        margin-bottom: 20px;
    }

    /deep/ .el-form-item:first-child .el-form-item__label {
        width: 60px !important;
    }
    .blue-border {
        /deep/ .el-input__inner {
            border-color: #409eff;
        }
    }
    // 去掉form-item默认的margin-bottom值和错误提示信息
    .table-form-class {
        /deep/ .el-form-item {
            margin-bottom: 0;
        }
        /deep/ .el-form-item__error {
            display: none;
        }
    }
    // 设置表单项校验框报红样式优先级，覆盖原有的蓝色边框
    .el-form-item.is-error {
        /deep/ .el-input__inner {
            border-color: red !important;
        }
    }
    .el-icon-error {
        color: red;
    }
    .price-exception-info {
        margin-bottom: 10px;
    }
    .configInfo {
        color: red;
        margin-left: 5px;
        font-weight: bold;
        font-size: 12px;
    }
    /deep/ .xx-upload {
        display: inline-block;
    }
    .promptInfo {
        color: red;
        margin-left: 0;
        font-weight: bold;
    }
    .active {
        color: red;
    }
}
/deep/ .quotation-radio {
    .el-radio__label {
        font-size: 12px;
    }
    .el-radio {
        margin-left: 0;
    }
    .el-radio + .el-radio {
        margin-left: 0;
        margin-top: 2px;
    }
}
</style>
